<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="newOrder()" class="btn fixed_btn">New Order</button>
      <div class="card">
        <p class="title">Purchase Orders</p>
        <table>
          <thead>
            <tr>
              <th>Order Number</th>
              <th>Created</th>
              <th>Status</th>
              <th>Total</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in orders">
              <tr :key="i" :class="{ grey: i % 2 }">
                <td data-label="Order Number">{{ item.order_number }}</td>
                <td data-label="Created">
                  {{ item.created_at | format_date }}
                </td>
                <td data-label="Status">{{ item.status }}</td>
                <td data-label="Total">
                  {{ formatPrice(item.total) }}
                </td>
                <td data-label="Details">
                  <img
                    @click="activate(item)"
                    :class="{
                      clickable: !details,
                      active: details == item.created_at,
                    }"
                    class="action"
                    src="@/assets/img/arrow.svg"
                  />
                </td>
              </tr>
              <transition :key="i" name="fade">
                <tr v-if="details == item.created_at">
                  <td colspan="100%">
                    <table class='units'>
                      <thead>
                        <tr>
                          <td>Product Name</td>
                          <td>Product Sku</td>
                          <td>Product Quantity</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in line_items" :key="item.id" class="unit">
                          <td data-label='Product Name'>{{item.name}}</td>
                          <td data-label='Product Sku'>{{item.sku}}</td>
                          <td data-label='Product Quantity'>{{item.quantity}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </transition>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "loginregister",
  components: {
    register: Register,
  },
  data() {
    return {
      details: null,
      orders: [],
      line_items: [],
      reseller: this.$store.state.reseller,
    };
  },
  mounted() {},
  firestore() {
    return {
      orders: db
        .collection(`reseller_profile/${this.reseller.id}/purchase_orders`)
        .orderBy("created_at", "desc"),
    };
  },
  updated() {},
  methods: {
    async activate(item) {
      let reseller = this.$store.state.reseller;
      if (this.details == item.created_at) {
        this.details = null;
        this.line_items = [];
      } else {
        await this.$bind(
          "line_items",
          db.collection(
            `reseller_profile/${this.reseller.id}/purchase_orders/${item.id}/line_items`
          )
        );
        this.details = item.created_at;
      }
    },
    newOrder() {
      let id = db.collection("products").doc().id;
      this.goTo("/purchaseOrder/" + id);
    },
    formatPrice(payload) {
      let formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return formatter.format(payload);
    },
  },
};
</script>

<style scoped lang="scss">
.units {
  background: rgba(73, 198, 212, 0.15);
  margin-bottom: 30px;
  thead {
    td {
      font-weight: bold;
      border-bottom: 2px solid rgba(73, 199, 212, 0.40);
      @media screen and (max-width: 700px){
        border-bottom: none;
      }
    }
  }
  tbody td {
    border-bottom: 1px solid rgba(73, 199, 212, 0.40);
    @media screen and (max-width: 700px){
      border-bottom: none;
    }
  }
  .unit {
    width: 100%;
    @media screen and (max-width: 700px){
      border-bottom: 2px solid rgba(73, 199, 212, 0.40);
    }
    p {
      display: flex;
      flex-direction: column;
      font-weight: bold;
      margin-right: 30px;
      margin-bottom: 15px;
      font-size: 14px;
      span {
        font-weight: normal;
        font-size: 18px;
      }
    }
  }
}
</style>
